import styled, { css } from 'styled-components';

export const ServerNickName = styled.p`
  ${({ theme, $hasNickname }) => css`
    font-size: 14px;
    line-height: 1.5;
    font-weight: ${theme.v3.font.weights.medium};
    background-color: ${$hasNickname ? theme.v3.colors.neutral[90] : 'transparent'};
    padding: ${$hasNickname ? '2px 8px' : '0'};
    border-radius: 30px;
    color: ${$hasNickname ? theme.v3.colors.neutral[50] : theme.v3.colors.neutral[40]};
    margin: 4px 0 0 0;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    cursor: pointer;
    
    &:hover {
      color: ${theme.v3.colors.neutral[40]};
    }
  `}
`;

export const NicknameEditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 5px 0 0 0;

  svg {
    position: relative;
    top: -1px;
  }
`;

export const NicknameEditTextField = styled.div`
  width: 100%;
  max-width: 200px;
`;

export const NicknameConfirmButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 50%;
    background-color: ${theme.v3.colors.brand.snappyBlue[50]};
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: ${theme.v3.colors.brand.snappyBlue[40]};
    }
  `}
`;
